import React from 'react';

import Tab from '@/Modules/tab/Tab';

import UserRole from './UserRole';

import UserVerify from './UserVerify';

const UserRoleManagement = () => (
  <Tab
    defaultActiveKey="1"
    initialPanes={[
      {
        title: 'User Account',
        content: <UserRole />,
        key: '1',
      },
       {
        title: 'User Verify',
        content: <UserVerify />,
        key: '2',
      },
    ]}
  />
);

export default UserRoleManagement;
